import moment from 'moment';

const DATE_FORMAT = 'DD MMM, YYYY';
const DATE_TIME_FORMAT = 'DD MMM, YYYY HH:mm';
const MONTH_FORMAT = 'MMM YYYY';

export const TIME_PICKER_FORMAT = 'hh:mm A';
export const TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT_SECOND = 'HH:mm:ss';

export const DATE_FORMAT_BODY_BE = 'YYYY-MM-DDTHH:mm:ss';

export const formatDateBodyBE = date => moment.utc(date).format(DATE_FORMAT_BODY_BE);

export const formatMonth = date => moment(date).format(MONTH_FORMAT);

export const formatDate = (date, format = DATE_FORMAT) => moment(date).format(format);

export const formatDateLocal = (date, format = DATE_FORMAT) =>
  moment.utc(date).local().format(format);

// ultil about time
export const isSameDate = (preTime, nextTime) => moment(preTime).isSame(moment(nextTime), 'day');

export const formatDateTime = date => moment(date).format(DATE_TIME_FORMAT);
export const formatDateTimeLocal = date => moment.utc(date).local().format(DATE_TIME_FORMAT);

export const getYearOlds = date => moment().diff(moment(date), 'years');

export const rangeDate = (startTime, endTime) => {
  const dateArray = [];
  let currentDate = moment(startTime);
  const stopDate = moment(endTime);
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
};

export const formatTime = (startAt, endAt) =>
  `${moment(startAt).format('HH:mm')} - ${moment(endAt).format('HH:mm')}`;

const Morning = 'morning';
const Afternoon = 'afternoon';
const Evening = 'evening';

export const meridiem = () => {
  const hour = moment().hour();

  if (hour > 16) {
    return Evening;
  }

  if (hour > 11) {
    return Afternoon;
  }

  return Morning;
};
export const formatDateBody = date => moment(date).format('YYYY-MM-DD');

export const getYearFromDate = date => (date ? moment(date).year() : '');
export const getMonthFromDate = date =>
  date ? `${moment(date).month() + 1}`.padStart(2, '0') : '';
export const formatDateTimeBodyUtc = date => moment(date).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
